/* eslint-disable */
export default {
  to: '至：',
  enterNameOrPhoneNumber: '输入号码',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
